'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var currentEventIdForAnnounce = exports.currentEventIdForAnnounce = function currentEventIdForAnnounce(state, fid) {
  return state.getIn(['announce', 'ui', fid, 'currentEvent']);
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/announce/paths.js
// module id = 617
// module chunks = 0